import script from "./AdminBookingReservations.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminBookingReservations.vue?vue&type=script&setup=true&lang=js"

import "./AdminBookingReservations.vue?vue&type=style&index=0&id=7bd93284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bd93284"]])

export default __exports__